import Phaser from 'phaser'
import { Monsters } from '../Story/Monsters';
import LevelScene from './LevelScene';
import { ArcLevelConfig } from '../Story/Arc';
import Level from '../Story/Level';
import MobGeneratorFactory from '../Story/MobGeneratorFactory';
import ImageHelpers from '../GUI/ImageHelpers';
import LevelConfigStorage from '../Storage/LevelConfigStorage';
import BackButton from '../GUI/BackButton';


export type SelectLevelConfig = {
    Configuration: ArcLevelConfig[],
    ArcFolder: string
};
/**
 * An arc has levels
 * This scene selects the level in an arc.
 */
export default class SelectLevelScene extends Phaser.Scene {
    private mBackground: Phaser.GameObjects.Image;
    private mLevelsButtons: Phaser.GameObjects.Image[];
    private mBackButton!: BackButton;

    private mLevelConfiguration: SelectLevelConfig;

    private mLevelConfigStorage: LevelConfigStorage;

    private mLevelNames: string[] = [];

    constructor() {
        super('SelectLevelScene');
        this.mLevelConfigStorage = new LevelConfigStorage();
    }
    init(obj: SelectLevelConfig) {
        this.mLevelConfiguration = obj;
    }

    preload() {
        this.load.image('selectLevelBackground', 'images/Scenes/SelectLevel.png');

        let thisScene = this;
        let index = 0;

        // This code keeps each onfig file in levelConfiguration_Index in the cache. 
        this.mLevelConfiguration.Configuration.forEach(lvlConfig => {
            let lvlConfigFile = `configuration/arcs/${thisScene.mLevelConfiguration.ArcFolder}/${lvlConfig.ConfigurationFile}`;
            thisScene.load.json(`levelConfiguration_${index}`, lvlConfigFile);
            thisScene.load.image(lvlConfig.CoverImage, `images/Levels/${lvlConfig.CoverImage}`);
            index++;
        });
        this.mLevelsButtons = [];

        BackButton.preload(this);
    }

    create() {
        let width = this.cameras.main.width;
        let height = this.cameras.main.height;
        this.mBackground = this.add.image(width / 2, height / 2, "selectLevelBackground");
        this.mBackground.setDisplaySize(width, height);
        this.mBackground.setDepth(-1);

        Monsters.create(this);

        let thisScene = this;
        let index = 0;


        this.mLevelConfiguration.Configuration.forEach(lvlConfig => {
            let levelData = thisScene.cache.json.get(`levelConfiguration_${index}`);
            /**
             *     "Name": "Practice",
                "Difficulty": "Easy",
                "GoldEarn": 10,
            
                "DurationLimitMinutes": 1,
                "StopLevelWhenTimeout": true,
            
                "Generators": [{
                        "Type": "Interval",
                        "DurationActiveMinutes": 1,
                        "IntervalSpawnSeconds": 5,
                        "DelaySecondUntilBegin": 0,
                        "IsActive": true,
                        "Mobs": ["PracticeHayTarget"]
                    },
                    {
                        "Type": "OneTime",
                        "DelaySecondUntilBegin": 50,
                        "IsActive": true,
                        "Mobs": ["PracticeHayBlock"]
            
                    }
                ]
             */
            let level = this.add.image(lvlConfig.MapAreaX, lvlConfig.MapAreaY, lvlConfig.CoverImage)
                .setInteractive()
                .on('pointerdown', () => {

                    let scene = new LevelScene();

                    let level = Level.CreateLevel(levelData.Name,
                        levelData.Generators,
                        levelData.DurationLimitMinutes,
                        levelData.Difficulty,
                        levelData.GoldEarn,
                        levelData.ExpEarn,
                        levelData.Background,
                        levelData.StopLevelWhenTimeout);

                    level.Generators = [];

                    levelData.Generators.forEach(gen => {
                        let generator = MobGeneratorFactory.Create(gen.Type, gen.Monsters, gen);
                        generator.AttachScene(scene);
                        generator.IsActive = true;
                        level.Generators.push(generator);
                    });

                    this.cameras.main.fade(200);
                    this.time.delayedCall(205, () => {
                        this.scene.add('LevelScene', scene, true, level);
                        this.scene.stop('SelectLevelScene');
                    });
                });
            ImageHelpers.SetHoverEffectOnImage(thisScene, level);
            let levelTitle = thisScene.add.text(0, lvlConfig.MapAreaY + 100, levelData.Name, { fontSize: 30, color: "white", fontStyle: "bold" });
            levelTitle.setX(level.x - levelTitle.width / 2);
            levelTitle.setVisible(false);

            level.on('pointerover', () => {
                levelTitle.setVisible(true);
            }).on("pointerout", () => {
                levelTitle.setVisible(false);
            });
            this.mLevelNames.push(levelData.Name);
            this.mLevelsButtons.push(level);

            index++;
        });

        let storageLevels = this.mLevelConfigStorage.GetLevelsCompleted();
        console.log(storageLevels);
        let levelsData = this.mLevelNames;

        this.mLevelsButtons.forEach((lvlBtn, index) => {

            // Level 1 is 0, so we always test the previous index.
            // Level 2 we want to check index 0 and not 1.
            let lastLevelCompleted = index == 0 ? true : storageLevels.includes(levelsData[index - 1]);

            if (!lastLevelCompleted) {
                lvlBtn.alpha = 0.5;
                lvlBtn.active = false;
                lvlBtn.off('pointerdown');
            }
        });

        this.mBackButton = new BackButton(this, "SelectArcScene"); // default bottom-left
    }

    update() {
        let thisScene = this;
        if (thisScene === null || thisScene.input === null || thisScene.input.keyboard === null) {
            return;
        }
        var keyObj = thisScene.input.keyboard.addKey('Esc');  // Get key object
        var isDown = keyObj.isDown;
        if (isDown) {
            this.scene.stop('SelectLevelScene');
            this.scene.remove('SelectLevelScene');
            this.scene.start('SelectArcScene');
        }
    }
}